<script setup lang="ts">
/**
 * Figma `Look` (Outfit 09 Result) — up to six pieces of a proposed outfit, framed and laid
 * out on a white card. A thumbnail, not a button: picking happens in the Playground.
 */
import { computed } from 'vue'
import type { AiraActionItem } from '@/features/aira/api/types'
import { OUTFIT_QUIZ_LOOK_SLOTS } from '../outfit-quiz.data'

const props = defineProps<{
  items: AiraActionItem[]
  label: string
}>()

const pieces = computed(() =>
  props.items
    .filter((item) => item.image)
    .slice(0, OUTFIT_QUIZ_LOOK_SLOTS.length)
    .map((item, index) => ({ item, slot: OUTFIT_QUIZ_LOOK_SLOTS[index]! })),
)
</script>

<template>
  <div
    class="outfit-quiz-look"
    role="img"
    :aria-label="label"
  >
    <span
      v-for="({ item, slot }, index) in pieces"
      :key="`${item.productId ?? item.wardrobeProductOverviewId}-${index}`"
      class="outfit-quiz-look__piece"
      :style="{
        left: `${slot.left}%`,
        top: `${slot.top}%`,
        width: `${slot.width}%`,
        height: `${slot.height}%`,
      }"
    >
      <img
        :src="item.image"
        alt=""
        loading="lazy"
      >
    </span>
  </div>
</template>
